<mat-card class="mat-elevation-z0" style="margin-top: 10px">
  <div class="justify-content-between d-flex">
    <span class="address-text space-left space-bottom">
      {{ typeTranslation }}
    </span>
  </div>

  <div class="d-flex">
    <div class="flexer">
      <div class="space-left">
        <div class="space-bottom">
          <div *ngIf="inputBoard.boardParts != null">
            <div
              *ngFor="
                let boardPart of inputBoard.boardParts;
                let i = index;
                let first = first;
                let last = last
              "
              [ngClass]="first && !last ? 'space-bottom' : ''"
            >
              <div *ngIf="inputBoard.boardParts.length > 1" class="strong">
                Bord #{{ i + 1 }}
              </div>

              <div class="strong">
                {{ boardPart.height | formatProductSize : boardPart.width }}
              </div>

              <div class="strong">
                {{
                  boardPart.boardType?.label
                    | joiner
                      : ' - '
                      : (boardPart.placementType?.ordinal
                          | placementTypeOrAlternative
                            : boardPart.placementType?.label
                            : boardPart.otherPlacementType
                            : '')
                }}
              </div>

              <div *ngIf="boardPart.material != null" class="strong">
                {{
                  boardPart.material.ordinal
                    | materialOrAlternative
                      : boardPart.material.name
                      : boardPart.otherMaterial
                      : 'Ander materiaal'
                }}
              </div>

              <div
                *ngIf="boardPart.showDistanceToBottom"
                class="strong preserve-line-break"
              >
                <span>
                  {{
                    boardPart.distanceToBottom
                      | distanceToBottomDisplay : boardPart.distanceToBottomText
                      | joiner
                        : ' -
                  '
                        : inputBoard.tilingFormats
                  }}
                </span>
              </div>

              <div *ngIf="boardPart.paintedPosts" class="strong">
                Geschilderde constructie:
                {{
                  boardPart.paintedPostsValue?.ordinal
                    | colorOrAlternative
                      : boardPart.paintedPostsValue?.label
                      : boardPart.paintedPostsText
                      : 'Andere kleur'
                }}
              </div>

              <div
                *ngIf="boardPart.layoutDescription?.length > 0"
                class="upper-space"
              >
                <span class="preserve-line-break">
                  {{ boardPart.layoutDescription }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="space-bottom">
          <div class="font-weight-bold">Ontwerp:</div>

          <span *ngIf="inputBoard.newDesign">
            De klant levert het ontwerp aan
          </span>

          <span *ngIf="inputBoard.newDesign != null && !inputBoard.newDesign">
            Inpress maakt het ontwerp aan
          </span>

          <div *ngIf="inputBoard.generalExtraInfo != null" class="upper-space">
            <span class="preserve-line-break">
              {{ inputBoard.generalExtraInfo }}
            </span>
          </div>
        </div>

        <div>
          <ul>
            <li>
              <span>Titel:</span>

              <span class="strong">&nbsp;{{ getTitle(inputBoard.title) }}</span>
            </li>

            <li>
              <span class="preserve-line-break display-contents">
                <span>{{ multiplePhoneNumbers ? 'Telnrs:' : 'Telnr:' }}</span>

                <span
                  *ngFor="
                    let group of productPhoneNumberGroups;
                    let last = last;
                    trackBy: trackById
                  "
                >
                  <span
                    class="strong"
                    *ngIf="productPhoneNumberGroups.length > 1"
                  >
                    {{ group.companyName }}:
                  </span>

                  <span
                    *ngFor="
                      let phoneNumber of group.phoneNumbers;
                      let ilast = last
                    "
                  >
                    <a class="click-link strong" href="tel:{{ phoneNumber }}">
                      &nbsp;{{ phoneNumber }}
                    </a>

                    <span class="strong">
                      {{ !ilast && group.phoneNumbers.length > 1 ? ',' : '' }}
                    </span>
                  </span>

                  <span class="strong">
                    {{
                      !last && productPhoneNumberGroups.length > 1 ? ' / ' : ''
                    }}
                  </span>
                </span>

                <span
                  class="strong"
                  *ngIf="productPhoneNumberGroups.length === 0"
                >
                  Geen telefoonnummers
                </span>
              </span>
            </li>

            <li>
              <span class="preserve-line-break display-contents">
                <span>Tekst: </span>

                <span class="inline-flex">
                  {{
                    inputBoard.text == null || inputBoard.text === ''
                      ? 'Geen
                  tekst'
                      : inputBoard.text
                  }}
                </span>
              </span>
            </li>

            <li *ngIf="inputBoard.immoscoopLogo != null">
              <img
                src="/assets/{{
                  inputBoard.immoscoopLogo
                    ? 'immoscoop_banner'
                    : 'immoscoop_banner_kruis'
                }}.png"
                class="immoscoop-logo"
              />
            </li>

            <li *ngIf="inputBoard.spottoLogo != null">
              <img
                src="/assets/{{
                  inputBoard.spottoLogo
                    ? 'spotto_banner'
                    : 'spotto_banner_kruis'
                }}.png"
                class="spotto-logo"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="!client || inputBoard.productAssets?.length > 0" class="flexer">
      <div class="d-flex images">
        <div *ngFor="let item of inputBoard.productAssets; index as i">
          <div
            *ngIf="
              (item?.archived === false || client) &&
              (item?.formSection === 'boardDesign' ||
                item?.formSection === 'internalDesign')
            "
            class="loadedImg align-middle"
            matTooltip="{{ item?.asset?.name }}"
          >
            <div class="d-flex box click-link" class="max-summary-width">
              <a
                download="{{ item.asset.name }}"
                href="/api/assets/{{ item.asset.uuid }}"
                style="margin-right: 7px"
                class="d-flex box"
              >
                <div class="filename">
                  {{ item?.asset?.name | shortenTextSplitOn : '.' : 10 }}
                </div>

                <a>
                  <mat-icon aria-hidden="false" aria-label="remove">
                    cloud_download
                  </mat-icon>
                </a>
              </a>
            </div>

            <a
              class="click-link"
              href="/api/assets/{{ item.asset.uuid }}"
              *ngIf="isImage(item.asset)"
              data-lightbox="product"
            >
              <img
                *ngIf="isImage(item.asset)"
                class="max-summary-width max-summary-height"
                src="/api/assets/{{ item.asset.uuid }}"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <board-price-summary
    *ngIf="client"
    [board]="inputBoard"
    [project]="inputProject"
  ></board-price-summary>
</mat-card>
